var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCohere(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    width: "75px",
    height: "75px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    d: "M24.3,44.7c2,0,6-0.1,11.6-2.4c6.5-2.7,19.3-7.5,28.6-12.5c6.5-3.5,9.3-8.1,9.3-14.3C73.8,7,66.9,0,58.3,0 h-36C10,0,0,10,0,22.3S9.4,44.7,24.3,44.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    d: "M30.4,60c0-6,3.6-11.5,9.2-13.8l11.3-4.7C62.4,36.8,75,45.2,75,57.6C75,67.2,67.2,75,57.6,75l-12.3,0 C37.1,75,30.4,68.3,30.4,60z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    d: "M12.9,47.6L12.9,47.6C5.8,47.6,0,53.4,0,60.5v1.7C0,69.2,5.8,75,12.9,75h0c7.1,0,12.9-5.8,12.9-12.9v-1.7 C25.7,53.4,20,47.6,12.9,47.6z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCohere);
export default __webpack_public_path__ + "static/media/Cohere.249d9dcaa96f61e9ea950ef1f6e1483b.svg";
export { ForwardRef as ReactComponent };